import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {IReservation, IReservationRequest, IReservationsRequest, IReservationsResponse} from '../models/IReservation';

@Injectable({
  providedIn: 'root'
})
export class ReservationsService {
  constructor(
    private http: HttpClient
  ) {
  }

  public getReservations(request: IReservationsRequest): Observable<IReservationsResponse> {
    return this.http.get<IReservationsResponse>(`${environment.apiUrl}/reservations`, {
      params: request as any
    });
  }

  public getReservationById(id: string): Observable<IReservation> {
    return this.http.get<IReservation>(`${environment.apiUrl}/reservations/${id}`);
  }

  public createReservation(reservation: IReservationRequest, locationId: string): Observable<void> {
    // TODO: remove dev function;
    if (localStorage.etaEnabled) {
      reservation.etaEnabled = true;
    }

    return this.http.post<void>(`${environment.apiUrl}/reservations/${locationId}`, reservation);
  }

  public updateReservation(reservation: IReservationRequest, reservationId: string): Observable<void> {
    return this.http.put<void>(`${environment.apiUrl}/reservations/${reservationId}`, reservation);
  }

  public cancelReservation(reservationId: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/reservations/${reservationId}`);
  }

  public updateEtaReservation(reservationId: string, date: string): Observable<void> {
    return this.http.put<void>(`${environment.apiUrl}/reservations/${reservationId}/eta`, date);
  }
}
